import { equals } from 'ramda'
import { useLocation } from 'react-router-dom'
import { makeQueryString } from '../url'
import { useSearchParams } from './useSearchParams'

type SearchParams = Record<string, string>

/**
 * @deprecated please use useModifySearchParams hook
 * this util skips React Router history and navigation and uses window.history.replaceState
 * directly which causes changes to URLs to not be tracked by React Router, as it all happens
 * outside of the context of the router
 */

export const useChangeSearchParam = () => {
  const search = useSearchParams()
  const { pathname } = useLocation()

  return (searchObj: Partial<SearchParams>) => {
    const newSearch = { ...search, ...searchObj }
    const url = `${pathname}${makeQueryString(newSearch)}`

    if (!equals(search, newSearch)) {
      window.history.replaceState(null, '', url)
    }
  }
}
